"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Web3Consumer = Web3Consumer;
exports.withWeb3 = withWeb3;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _web = _interopRequireDefault(require("web3"));

var _Web3Context = _interopRequireDefault(require("./Web3Context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // define custom error codes


var ETHEREUM_ACCESS_DENIED = 'ETHEREUM_ACCESS_DENIED';
var NO_WEB3 = 'NO_WEB3'; // web3 manager

var initialWeb3State = {
  web3js: undefined,
  account: undefined,
  networkId: undefined,
  usingProviderURL: undefined
};

function web3StateReducer(state, action) {
  switch (action.type) {
    case 'INITIALIZE':
      return _objectSpread({}, state, {
        web3js: action.payload,
        usingProviderURL: false
      });

    case 'INITIALIZE_URL':
      return _objectSpread({}, state, {
        web3js: action.payload,
        usingProviderURL: true
      });

    case 'UPDATE_NETWORK_ID':
      return _objectSpread({}, state, {
        networkId: action.payload
      });

    case 'UPDATE_ACCOUNT':
      return _objectSpread({}, state, {
        account: action.payload
      });

    default:
      return initialWeb3State;
  }
}

function useWeb3Manager(pollTime, providerURL) {
  var _useReducer = (0, _react.useReducer)(web3StateReducer, initialWeb3State),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      web3State = _useReducer2[0],
      dispatchWeb3State = _useReducer2[1]; // compute initialization status


  var web3Initialized = web3State.web3js && web3State.account !== undefined && web3State.networkId; // web3 error ref

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      web3Error = _useState2[0],
      setWeb3Error = _useState2[1];

  (0, _react.useEffect)(function () {
    if (web3Initialized && web3Error) setWeb3Error(null);
  }); // run one-time initialization

  (0, _react.useEffect)(function () {
    var _window = window,
        web3 = _window.web3,
        ethereum = _window.ethereum; // for modern dapp browsers

    if (ethereum) ethereum.enable().then(function () {
      var web3js = new _web.default(ethereum);
      dispatchWeb3State({
        type: 'INITIALIZE',
        payload: web3js
      });
    }).catch(function (deniedAccessMessage) {
      var deniedAccessError = Error(deniedAccessMessage.toString());
      deniedAccessError.code = ETHEREUM_ACCESS_DENIED;
      setWeb3Error(deniedAccessError);
    }); // for legacy dapp browsers
    else if (web3 && web3.currentProvider) {
        var web3js = new _web.default(web3.currentProvider);
        dispatchWeb3State({
          type: 'INITIALIZE',
          payload: web3js
        });
      } // use providerURL as a backup
      else if (providerURL) {
          var _web3js = new _web.default(providerURL);

          dispatchWeb3State({
            type: 'INITIALIZE_URL',
            payload: _web3js
          });
        } // no web3 detected
        else {
            var noWeb3Error = Error('No Web3 Provider Detected.');
            noWeb3Error.code = NO_WEB3;
            setWeb3Error(noWeb3Error);
          }
  }, []);

  function networkPoll() {
    web3State.web3js.eth.net.getId().then(function (networkId) {
      if (networkId !== web3State.networkId) dispatchWeb3State({
        type: 'UPDATE_NETWORK_ID',
        payload: networkId
      });
    }).catch(function (error) {
      return setWeb3Error(error);
    });
  }

  function accountPoll() {
    web3State.web3js.eth.getAccounts().then(function (accounts) {
      var account = accounts === undefined || accounts[0] === undefined ? null : accounts[0];
      if (account !== web3State.account) dispatchWeb3State({
        type: 'UPDATE_ACCOUNT',
        payload: account
      });
    }).catch(function (error) {
      return setWeb3Error(error);
    });
  }

  (0, _react.useEffect)(function () {
    if (web3State.web3js) {
      networkPoll();
      var networkPollInterval = setInterval(networkPoll, pollTime);
      return function () {
        return clearInterval(networkPollInterval);
      };
    }
  }, [web3State.web3js, web3State.networkId]);
  (0, _react.useEffect)(function () {
    if (web3State.web3js) {
      accountPoll();
      var accountPollInterval = setInterval(accountPoll, pollTime);
      return function () {
        return clearInterval(accountPollInterval);
      };
    }
  }, [web3State.web3js, web3State.account]); // reRenderers

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      accountReRenderer = _useState4[0],
      setAccountReRenderer = _useState4[1];

  function forceAccountReRender() {
    setAccountReRenderer(accountReRenderer + 1);
  }

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      networkReRenderer = _useState6[0],
      setNetworkReRenderer = _useState6[1];

  function forceNetworkReRender() {
    setNetworkReRenderer(networkReRenderer + 1);
  }

  var usingProviderURL = web3State.usingProviderURL,
      rest = _objectWithoutProperties(web3State, ["usingProviderURL"]);

  return [rest, web3Initialized, usingProviderURL, web3Error, {
    accountReRenderer: accountReRenderer,
    forceAccountReRender: forceAccountReRender,
    networkReRenderer: networkReRenderer,
    forceNetworkReRender: forceNetworkReRender
  }];
}

function Web3Provider(_ref) {
  var screens = _ref.screens,
      providerURL = _ref.providerURL,
      pollTime = _ref.pollTime,
      supportedNetworks = _ref.supportedNetworks,
      accountRequired = _ref.accountRequired,
      children = _ref.children;

  var _arr2 = Object.keys(defaultScreens);

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var defaultScreen = _arr2[_i2];
    screens[defaultScreen] = screens[defaultScreen] || defaultScreens[defaultScreen];
  }

  var Initializing = screens.Initializing,
      NoWeb3 = screens.NoWeb3,
      PermissionNeeded = screens.PermissionNeeded,
      UnlockNeeded = screens.UnlockNeeded,
      UnsupportedNetwork = screens.UnsupportedNetwork,
      Web3Error = screens.Web3Error;

  var _useWeb3Manager = useWeb3Manager(pollTime, providerURL),
      _useWeb3Manager2 = _slicedToArray(_useWeb3Manager, 5),
      web3State = _useWeb3Manager2[0],
      web3Initialized = _useWeb3Manager2[1],
      usingProviderURL = _useWeb3Manager2[2],
      web3Error = _useWeb3Manager2[3],
      reRenderers = _useWeb3Manager2[4];

  var Body = function Body() {
    if (web3Error) {
      if (web3Error.code === ETHEREUM_ACCESS_DENIED) return _react.default.createElement(PermissionNeeded, null);else if (web3Error.code === NO_WEB3) return _react.default.createElement(NoWeb3, null);else return _react.default.createElement(Web3Error, {
        error: web3Error
      });
    }

    if (!web3Initialized) return _react.default.createElement(Initializing, null);
    if (!supportedNetworks.includes(web3State.networkId)) return _react.default.createElement(UnsupportedNetwork, {
      supportedNetworkIds: supportedNetworks
    });
    if (accountRequired && !usingProviderURL && web3State.account === null) return _react.default.createElement(UnlockNeeded, null);
    return _react.default.createElement(_Web3Context.default.Provider, {
      value: _objectSpread({}, web3State, {
        reRenderers: reRenderers
      })
    }, children);
  };

  return _react.default.createElement(_react.Suspense, {
    fallback: _react.default.createElement("div", null)
  }, Body());
}

var screens = {
  Initializing: _propTypes.default.any,
  NoWeb3: _propTypes.default.any,
  PermissionNeeded: _propTypes.default.any,
  UnlockNeeded: _propTypes.default.any,
  UnsupportedNetwork: _propTypes.default.any,
  Web3Error: _propTypes.default.any
};
var defaultScreens = {
  Initializing: _react.default.lazy(function () {
    return import('./defaultScreens/Initializing');
  }),
  NoWeb3: _react.default.lazy(function () {
    return import('./defaultScreens/NoWeb3');
  }),
  PermissionNeeded: _react.default.lazy(function () {
    return import('./defaultScreens/PermissionNeeded');
  }),
  UnlockNeeded: _react.default.lazy(function () {
    return import('./defaultScreens/UnlockNeeded');
  }),
  UnsupportedNetwork: _react.default.lazy(function () {
    return import('./defaultScreens/UnsupportedNetwork');
  }),
  Web3Error: _react.default.lazy(function () {
    return import('./defaultScreens/Web3Error');
  })
};
Web3Provider.propTypes = {
  screens: _propTypes.default.shape(screens),
  providerURL: _propTypes.default.string,
  pollTime: _propTypes.default.number,
  supportedNetworks: _propTypes.default.arrayOf(_propTypes.default.number),
  accountRequired: _propTypes.default.bool,
  children: _propTypes.default.node
};
Web3Provider.defaultProps = {
  screens: defaultScreens,
  pollTime: 1000,
  supportedNetworks: [1, 3, 4, 42],
  accountRequired: true
};
var _default = Web3Provider; // render props pattern: the consumer is exposed to give access to the web3 context via render props

exports.default = _default;

function Web3Consumer(props) {
  var recreateOnNetworkChange = props.recreateOnNetworkChange,
      recreateOnAccountChange = props.recreateOnAccountChange,
      children = props.children;
  return _react.default.createElement(_Web3Context.default.Consumer, null, function (context) {
    return _react.default.createElement(_react.Fragment, {
      key: recreateOnNetworkChange ? context.networkId : undefined
    }, _react.default.createElement(_react.Fragment, {
      key: recreateOnAccountChange ? context.account : undefined
    }, children(context)));
  });
}

Web3Consumer.propTypes = {
  recreateOnNetworkChange: _propTypes.default.bool,
  recreateOnAccountChange: _propTypes.default.bool,
  children: _propTypes.default.func.isRequired
};
Web3Consumer.defaultProps = {
  recreateOnAccountChange: true,
  recreateOnNetworkChange: true
}; // HOC pattern: withWeb3 is an wrapper that gives passed components access to the web3 context

function withWeb3(ComponentToWrap, props) {
  var _ref2 = props || {},
      recreateOnNetworkChange = _ref2.recreateOnNetworkChange,
      recreateOnAccountChange = _ref2.recreateOnAccountChange;

  var WithWeb3 =
  /*#__PURE__*/
  function (_Component) {
    _inherits(WithWeb3, _Component);

    function WithWeb3() {
      _classCallCheck(this, WithWeb3);

      return _possibleConstructorReturn(this, _getPrototypeOf(WithWeb3).apply(this, arguments));
    }

    _createClass(WithWeb3, [{
      key: "render",
      value: function render() {
        var _this = this;

        return _react.default.createElement(Web3Consumer, {
          recreateOnNetworkChange: recreateOnNetworkChange || true,
          recreateOnAccountChange: recreateOnAccountChange || true
        }, function (context) {
          return _react.default.createElement(ComponentToWrap, _extends({}, _this.props, {
            web3: context
          }));
        });
      }
    }]);

    return WithWeb3;
  }(_react.Component);

  WithWeb3.displayName = "WithWeb3(".concat(ComponentToWrap.displayName || ComponentToWrap.name || 'Component', ")");
  return WithWeb3;
}